<template>
  <div class="container-fluid">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.product.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.product.label') }}
            <v-select
              v-model="form.product_id"
              :options="product_select"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.dealer.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="dealer_id">
            {{$t('modal.form.dealer.label')}}

            <v-select
              v-model="form.dealer_id"
              :options="dealers_select"
              label="label"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.warehouse.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="warehouse_id">
            {{$t('modal.form.warehouse.label')}}

            <v-select
              v-model="form.warehouse_id"
              :options="warehouse_select"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.quantity.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="quantity">
            {{$t('modal.form.quantity.label')}}

            <input class="w-100"
              v-model="form.quantity"
              type="number"
              :placeholder="$t('modal.form.quantity.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.price.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="price">
            {{$t('modal.form.price.label')}}

            <input class="w-100"
              v-model="form.price"
              type="number"
              :placeholder="$t('modal.form.price.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <b-button class="float-end ms-3"
          variant="primary"
          type="submit"
                  :disabled="db"
        >
          {{$t('modal.button.post')}}
        </b-button>

        <b-button class="float-end "
          variant="warning"
          @click="onClose"
        >
          {{$t('modal.button.back')}}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { postIncomes } from '../../../api/endpoints/incomes';

  export default {
    name: "IncomePostModal",
    props: {
      product_select: {
        type: Array,
        required: true
      },
      warehouse_select: {
        type: Array,
        required: true
      },
      dealers_select: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        form: {
          product_id: null,
          dealer_id: null,
          warehouse_id: null,
          status: 1,
          quantity: null,
          price: null,
          stock_type: 1,
        },
        db: false,
      }
    },
    methods: {
      async onSubmit() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        const isValid = await this.$refs.observer.validate()

      if(isValid) {
        this.form.product_id = this.form.product_id.value;
        this.form.dealer_id = this.form.dealer_id.value;
        this.form.warehouse_id = this.form.warehouse_id.value;
        postIncomes(this.form).then( () => {
          this.onClose()
        })
      }
      },
      onClose() {
        this.$emit('onClose')
      }
    }
  }
</script>
